import classes from "./RatioGlyph.module.css";

/** A small box at the chosen aspect ratio ("16:9"), the live ratio select's glyph. */
export function RatioGlyph({ ratio }: { ratio: string | null }) {
  const [width, height] = (ratio ?? "1:1").split(":").map(Number);
  const wide = (width ?? 1) >= (height ?? 1);
  const shape = { aspectRatio: `${width ?? 1} / ${height ?? 1}`, [wide ? "width" : "height"]: 16 };
  return <span className={classes.ratio} style={shape} aria-hidden />;
}
